export default (message = '') => ({
	message,
	invalid: false,
	rawValue: '',

	// METHODS
	formatPhoneNumber(digits) {
		// Limit to 10 digits
		const limited = digits.substring(0, 10);
		
		// Format as (***) ***-****
		let formatted = '';
		if (limited.length > 0) {
			formatted = '(' + limited.substring(0, 3);
			if (limited.length >= 4) {
				formatted += ') ' + limited.substring(3, 6);
				if (limited.length >= 7) {
					formatted += '-' + limited.substring(6, 10);
				}
			}
		}
		
		return formatted;
	},

	handleKeyDown(event) {
		const key = event.key;
		const input = event.target;
		
		// Allow: backspace, delete, tab, escape, enter
		if (['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(key)) {
			return;
		}
		
		// Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
		if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(key.toLowerCase())) {
			return;
		}
		
		// Get current digits count
		const currentDigits = input.value.replace(/\D/g, '');
		
		// Prevent if not a number or if already at 10 digits
		if (!/^\d$/.test(key) || currentDigits.length >= 10) {
			event.preventDefault();
		}
	},

	handleInput(event) {
		const input = event.target;
		
		// Get only digits from the input
		const digits = input.value.replace(/\D/g, '');
		this.rawValue = digits;
		
		// Format the phone number
		const formatted = this.formatPhoneNumber(digits);
		
		// Store cursor position before updating
		const cursorPosition = input.selectionStart;
		const previousValue = input.value;
		
		// Update value
		input.value = formatted;
		
		// Calculate new cursor position
		if (formatted.length > previousValue.length) {
			// If we're adding characters, move cursor forward
			const diff = formatted.length - previousValue.length;
			input.setSelectionRange(cursorPosition + diff, cursorPosition + diff);
		} else if (formatted.length < previousValue.length) {
			// If we're removing characters, keep cursor in place or move back
			input.setSelectionRange(cursorPosition, cursorPosition);
		} else {
			// Same length, keep cursor position
			input.setSelectionRange(cursorPosition, cursorPosition);
		}
	},

	handlePaste(event) {
		event.preventDefault();
		const pastedData = event.clipboardData.getData('text');
		const digits = pastedData.replace(/\D/g, '').substring(0, 10);
		event.target.value = this.formatPhoneNumber(digits);
		this.rawValue = digits;
	},

	reportValidity() {
		// Dispatch custom event to tie into.
		this.$refs.input.dispatchEvent(new CustomEvent('validation-update', { bubbles: true }));

		let { validity, validationMessage, dataset } = this.$refs.input;

		// Give execution time for the validationUpdate event listeners to fire.
		// Mark if the input is invalid.
		this.invalid = !validity.valid;

		// Check the input's data attributes for custom messages.
		for (let key in validity) {
			if (validity[key] && (key in dataset)) {
				this.message = dataset[key];
				return;
			}
		}

		// Fall back to the browser default message.
		this.message = validationMessage;
	},

	// ELEMENTS
	input: {
		'x-ref': 'input',
		'@keydown'(event) {
			this.handleKeyDown(event);
		},
		'@input'(event) {
			this.handleInput(event);
		},
		'@paste'(event) {
			this.handlePaste(event);
		},
		'@blur': 'reportValidity',
		'@invalid.prevent': 'reportValidity',
		':style'() {
			return this.invalid ? {
				'--color-background': 'var(--color-alert-background)',
				'--color-border': 'var(--color-alert-foreground)',
			} : '';
		},
		':aria-invalid'() {
			return !!this.message;
		},
	},
	error: {
		'role': 'status',
		'x-ref': 'error',
		'x-text'() {
			return this.message;
		},
	},
});
